import axios from "axios";
import {
  startAvailableSlot,
  successAvailableSlot,
  errorAvailableSlot,
} from "../../slice/Appointment";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAvailableSlots = (counsellorId, startDate, endDate) => {
  return async (dispatch) => {
    dispatch(startAvailableSlot());
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.get(
        `${API_BASE_URL}/counsellor/${counsellorId}/available-slot?startDate=${startDate}&endDate=${endDate}`,
        config
      );
      dispatch(successAvailableSlot(response.data));
      return response.data;
    } catch (error) {
      dispatch(errorAvailableSlot(error.message));
      return error;
    }
  };
};